module.exports = __webpack_public_path__ + "static/img/voc-img-01.bacbf08.png";